import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';
import { Build } from '@mui/icons-material';
import { SkillsManager } from '../components/skills/SkillsManager';
import { useProject } from '../contexts/ProjectContext';

const SkillsPage: React.FC = () => {
  const { currentProject } = useProject();

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            fontWeight: 'bold',
            color: 'primary.main'
          }}
        >
          <Build />
          Skills Management
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
          Manage skills that can be assigned to vehicles and required by jobs. 
          Create, edit, and analyze skill usage across your VRP system.
        </Typography>
      </Box>

      <Paper elevation={2} sx={{ borderRadius: 2 }}>
        {currentProject ? (
          <SkillsManager 
            projectId={currentProject.id} 
            selectionMode={false}
          />
        ) : (
          <Typography variant="body1" color="text.secondary" sx={{ p: 3 }}>
            Please select a project to manage skills.
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default SkillsPage;
